import React, {memo} from "react";
import styles from "./styles.module.scss";
import {TextBold12, TextMedium14, ThirtyText} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import {t} from "i18next";
import {CourtsRequestModel, CourtTypeEnum, courtTypeValues} from "@/app/api/courts";
import Chip from "@/app/components/chip";
import classNames from "classnames";
import LazyAssets from "@/app/utils/assets_widget";
import Space from "@/app/components/space";
import Button from "@/app/components/button";

interface Props {
  filters: CourtsRequestModel
  setType: (type: CourtTypeEnum) => void
  setBookingRequired: (bookingRequired: boolean) => void
  setArtificialLight: (artificialLight: boolean) => void
  setLockerRooms: (lockerRooms: boolean) => void
  setParkingAvailability: (parkingAvailability: boolean) => void
  setCoachAvailable: (coachAvailable: boolean) => void
  setSocialVibe: (socialVibe: boolean) => void
  setHasCafeOrBar: (hasCafeOrBar: boolean) => void
  setRentalGearAvailable: (rentalGearAvailable: boolean) => void
  setMinRating: (minRating: number | undefined) => void
  clearFilters: () => void
  applyFilters: (filters: CourtsRequestModel) => void
}

const FiltersForMap: React.FC<Props> = ({
                                          filters,
                                          setType,
                                          setArtificialLight,
                                          setLockerRooms,
                                          setParkingAvailability,
                                          setBookingRequired,
                                          setMinRating,
                                          clearFilters,
                                          applyFilters,
                                          setCoachAvailable,
                                          setSocialVibe,
                                          setHasCafeOrBar,
                                          setRentalGearAvailable
                                        }) => {
  return (
    <div className={styles.filters}>
      <ThirtyText text={t(s.filters)}/>
      <div className={styles.chips}>
        {courtTypeValues.map((type) => (
          <Chip key={type} text={t(type.replaceAll("_", " "))} isActive={filters.type?.includes(type)}
                onClick={() => setType(type)}/>))}
      </div>
      <ThirtyText text={t(s.placeOptions)}/>
      <div className={styles.chips}>
        <Chip text={t(s.artificialLight)} isActive={filters.artificialLight}
              onClick={() => setArtificialLight(!filters.artificialLight)}/>
        <Chip text={t(s.lockerRooms)} isActive={filters.lockerRooms}
              onClick={() => setLockerRooms(!filters.lockerRooms)}/>
        <Chip text={t(s.parkingAvailability)} isActive={filters.parkingAvailability}
              onClick={() => setParkingAvailability(!filters.parkingAvailability)}/>
        <Chip text={t(s.bookingRequired)} isActive={filters.bookingRequired}
              onClick={() => setBookingRequired(!filters.bookingRequired)}/>
        <Chip text={t(s.coachAvailable)} isActive={filters.coachAvailable}
              onClick={() => setCoachAvailable(!filters.coachAvailable)}/>
        <Chip text={t(s.socialVibe)} isActive={filters.socialVibe}
              onClick={() => setSocialVibe(!filters.socialVibe)}/>
        <Chip text={t(s.cafeBar)} isActive={filters.hasCafeOrBar}
              onClick={() => setHasCafeOrBar(!filters.hasCafeOrBar)}/>
        <Chip text={t(s.rentalGear)} isActive={filters.rentalGearAvailable}
              onClick={() => setRentalGearAvailable(!filters.rentalGearAvailable)}/>
      </div>
      <div className={styles.inRow}>
        <ThirtyText text={t(s.rating)}/>
        <TextBold12 text={t(s.notLessThan)} className={styles.notLessThan}/>
      </div>
      <div className={styles.chips}>
        {[undefined, 3.5, 4, 4.5].map((rating) => (
          <Chip key={rating}
                child={<div className={classNames(styles.inRating, {[styles.active]: filters.minRating === rating})}>
                  {rating !== undefined && <LazyAssets.Star className={styles.star}/>}
                  <TextMedium14 text={rating === undefined ? t(s.all) : rating?.toString()}/>
                </div>}
                isActive={filters.minRating === rating}
                onClick={() => setMinRating(rating)}/>))}
      </div>
      <Space.H32/>
      <Button text={t(s.clean)} onClick={clearFilters} isOutline/>
      <Button text={t(s.apply)} onClick={() => applyFilters(filters)}/>
    </div>
  );
};

export default memo(FiltersForMap);